const ENCOUNTER_D20_MIN = 16

export default ENCOUNTER_D20_MIN
